import moment from 'moment';
import { getDtd, getFareType, passengerCount } from '../../../../utilities/helpers';
import { sendAncillaryEventToCustomerIO } from '../../../../utilities/customer-io-ancillary-events';

export default (pnrInfo, seatsData, indexFligth, sections) => {
  const items = [];
  let tripType = 'MC';
  const segments = [];
  let zone = 'NA';
  const legCollection = pnrInfo?.legCollection || [];
  const outboundSegments = legCollection?.[0]?.segmentsCollection || [];
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection || [];
  let stopNumbers = 0;

  if (pnrInfo?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrInfo?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  if (legCollection?.length > 0) {
    legCollection.forEach((element) => {
      const data = element.segmentsCollection;
      stopNumbers = data?.length > 1 ? stopNumbers + (data?.length - 1) : stopNumbers;
      data.forEach((segmentsData) => {
        segments.push(segmentsData);
      });
    });
  }

  const dtd = getDtd(segments?.[0]?.departureDateTime);
  const inboundDepartureDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const marketSegments = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = (segmentCollection || []).map(segment => {
      return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');

  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';
  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}`;
  }
  
  const bookingClassTest = [];
  const cabinClassTest = [];
  (legCollection || []).forEach((element) => {
    const segmentsInfo = element?.segmentsCollection;
    const bookingClass = [];
    const cabinClass = [];
    (segmentsInfo || []).forEach((segmentsData) => {
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');

  const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
  const travelerCollection = pnrInfo?.cart?.travelerCollection || [];
  const travelerCount = passengerCount(travelerCollection);

  const apiItem = apiDepartureDate.diff(transactionDate, 'days');
  const transactionDate = moment(pnrInfo?.creationDate);
  const market = pnrInfo?.globalMarketFlight;
  const mktCarrier = legCollection.map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = (segmentCollection || []).map(segment => {
      return `${segment?.marketingCarrier || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');

  if (market === 'DOMESTIC') {
    zone = 'DOM';
  } else if (market === 'INTERNATIONAL' || market === 'TRANSBORDER') {
    zone = 'INT';
  }

  const brandedFare = [];
  const itemName = [];
  let zoneItem = '';
  let regionItem = '';
  const departureDateTime = [];
  const outboundDepartureDateItem = [];
  let flightTimeMinutes = 0;
  (legCollection || []).forEach((legs, legIndex) => {
    const itemNameOWType = legs?.segmentsCollection?.[0]?.departureAirport + legs?.segmentsCollection?.[0]?.arrivalAirport;
    const itemNameRTType = legs?.segmentsCollection?.[0]?.departureAirport + legs?.segmentsCollection?.[1]?.arrivalAirport;
    if (tripType !== 'MC' && legIndex === 0) {
      if ((tripType === 'OW' || tripType === 'RT') && legs?.segmentsCollection?.length === 1) {
        itemName.push(itemNameOWType);
      } else {
        itemName.push(itemNameRTType);
      }
    } else if (tripType === 'MC') {
      if (legs?.segmentsCollection?.length === 1) {
        itemName.push(itemNameOWType);
      } else {
        itemName.push(itemNameRTType);
      }
    }
    
    const brandedFareSegments = [];
    const outboundDepartureSegments = [];
    const departureDateTimeSegments = [];
    (legs?.segmentsCollection || []).forEach((passenger, index) => {
      const brandFare = getFareType(passenger);
      if (index === 0 && legIndex === 0 && tripType !== 'MC') {
        departureDateTime.push(moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss'));
        flightTimeMinutes = passenger?.flightDurationInMinutes;
        outboundDepartureDateItem.push(passenger?.departureDateTime?.format('YYYYMMDD'));
        brandedFare.push(brandFare);
      } else if (tripType === 'MC') {
        departureDateTimeSegments.push(moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss'));
        flightTimeMinutes += passenger?.flightDurationInMinutes;
        outboundDepartureSegments.push(passenger?.departureDateTime?.format('YYYYMMDD'));
        brandedFareSegments.push(brandFare);
      }

      if (tripType !== 'MC') {
        zoneItem = passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT';
        regionItem = passenger?.regionKeyFromLeg;
      } else if (index === legs.segmentsCollection.length - 1) {
        zoneItem = passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT';
        regionItem = passenger?.regionKeyFromLeg;
      }
    });

    if (tripType === 'MC') {
      brandedFare.push(brandedFareSegments.join('/'));
      outboundDepartureDateItem.push(outboundDepartureSegments.join('/'));
      departureDateTime.push(departureDateTimeSegments.join('/'));
    }
  });

  const apItemRanges = [
    { min: 0, max: 2, range: '0 a 2' },
    { min: 3, max: 6, range: '3 a 6' },
    { min: 7, max: 13, range: '7 a 13' },
    { min: 14, max: 20, range: '14 a 20' },
    { min: 21, max: 27, range: '21 a 27' },
    { min: 28, max: 49, range: '28 a 49' },
    { min: 50, max: 89, range: '50 a 89' },
    { min: 90, max: 119, range: '90 a 119' },
    { min: 120, max: 149, range: '120 a 149' },
    { min: 150, max: Infinity, range: '150+' },
  ];

  const apItemRange = apItemRanges.find(({ min, max }) => apiItem >= min && apiItem <= max)?.range || 'NA';

  let msItem = 0;
  if (tripType === 'RT') {
    const firstSegment = moment(segments?.[0]?.departureDateTime);
    const lastSegment = moment(segments?.[segments?.length - 1]?.arrivalDateTime);
    msItem = lastSegment.diff(firstSegment, 'days');
  }

  let params = {};
  const itemCategory = 'Ancillary';
  const itemCategory2 = 'seat';
  let itemCategory3 = 'NA';
  const price = 0;
  let quantity = 0;
  const flightTime = moment.utc(flightTimeMinutes * 60000).format('HH:mm');

  const marketOdItem = legCollection?.[indexFligth]?.segmentsCollection?.[0]?.departureAirport + legCollection?.[indexFligth]?.segmentsCollection?.[0]?.arrivalAirport;
  Object.keys(seatsData).forEach(element => {
    legCollection.forEach((legs) => {
      (legs?.segmentsCollection || []).forEach((passenger, index) => {
        const itemBrand = 'AM';
        const opCarrier = passenger?.operatingCarrier;
        let premierSeatCount = 0;
        const segment = passenger?.departureAirport + passenger?.arrivalAirport;
        const itemListName = 'Ancillaries';

        if (segment === marketOdItem) {
          params = {
            'item_name': itemName.join('-') || 'NA',
            'coupon': 'NA',
            'discount': 0,
            'fop_type': 'Cash',
            'item_brand': itemBrand,
            'item_list_name': itemListName,
            'item_affiliation': 'AM',
            'index': index,
            'booking_fee_amrpoints': 0,
            'market_ndod_item': marketNdod || 'NA',
            'market_od_item': marketOdItem || 'NA',
            'market_segment_item': marketOdItem || 'NA',
            'zone_item': zoneItem || 'NA',
            'region_item': regionItem || 'NA',
            'flight_time_dep': departureDateTime.join('-') || 'NA',
            'flight_time': flightTime || 'NA',
            'branded_fare': brandedFare.join('-') || 'NA',
            'outbound_departure_date_item': outboundDepartureDateItem.join('-') || 'NA',
            'inbound_departure_date_item': inboundDepartureDate,
            'price_points': pnrInfo?.cart?.points || 0,
            'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
            'aircraft_type': passenger?.aircraftType || 'NA',
            'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
            'ap_item': apItemRange,
            'op_carrier': opCarrier || 'NA',
            'ms_item': msItem,
            'cabin_item': tripType === 'MC' ? cabinClassSegment : passenger?.cabin || 'NA',
            'class_item': tripType === 'MC' ? bookingClassSegment : passenger?.bookingClass || 'NA',
          };
          let breakParams = false;
          switch (element) {
            case 'amPlus':
              quantity = seatsData[element];
              itemCategory3 = 'AM Plus';
              break;
            case 'coach':
              quantity = seatsData[element];
              itemCategory3 = 'Tourist Seat';
              break;
            case 'exitRow':
              quantity = seatsData[element];
              itemCategory3 = 'Emergency seats';
              break;
            case 'preferred':
              quantity = seatsData[element];
              itemCategory3 = 'Preferred seats';
              break;
            default:
              const premierSeatData = sections?.filter(section => {
                return section?.code === 'FIRST_CLASS';
              });

              if (premierSeatData) {
                itemCategory3 = 'Premier';
                // eslint-disable-next-line no-unused-expressions
                premierSeatData[0]?.rows?.forEach(element => element?.seats?.filter(seat => {
                  if (seat?.status === 'AVAILABLE') {
                    premierSeatCount++;
                  }
                  return premierSeatCount;
                }));
                params['item_category'] = itemCategory;
                params['item_category2'] = itemCategory2;
                params['item_category3'] = itemCategory3;
                params['price'] = price;
                params['quantity'] = premierSeatCount || 1;
              }
              breakParams = true;
              break;
          }

          if (!breakParams) {
            params['item_category'] = itemCategory;
            params['item_category2'] = itemCategory2;
            params['item_category3'] = itemCategory3;
            params['price'] = price;
            params['quantity'] = quantity || 1;
          }
        }
      });
    });
    if (params['item_category'] && params['item_name'] !== null) {
      items.push(params);
    }
  });

  const updatedItems = items.filter((obj, index, item) =>
    index === item.findIndex((value) => (
      value?.item_name === obj?.item_name && value?.item_category3 === obj?.item_category3
    ))
  );

  const result = {
    event: 'view_item_list',
    ecommerce: {
      'search_filter': 'NA',
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Ancillary',
      'trip_type': tripType,
      'fop_type': 'Cash',
      'outbound_departure_date': outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone,
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegments || 'NA',
      'mkt_carrier': mktCarrier,
      'region': legCollection?.[0]?.regionKey || 'NA',
      'value_points': pnrInfo?.cart?.points || 0,
      'adults': travelerCount?.adults,
      'childs': travelerCount?.child,
      'adult_minors': travelerCount?.adultMinors,
      'infants': travelerCount?.infants,
      'stops_number': stopNumbers,
      'dtd': dtd || 'NA',
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': updatedItems,
    },
  };

  try {
    sendAncillaryEventToCustomerIO('seatselection', result, pnrInfo);
  } catch (error) {
    // Silent error
  }

  return result;
};
